<template>
  <div class="right-dialog">
    <div class="title">
      <div class="trapezoid"></div>
      <div class="title-text">订单常见问题</div>
    </div>
    <div class="item" :key="index" v-for="(item,index) in questionList">
      <div style="cursor: pointer" @click="clickSwitch(index,item,item.flag)" class="question" >
        <div>{{index+1}}.{{item.title}}</div>
        <img  v-show="item.flag" src="../assets/make/rightDialog/right-dialog-open.png" style="width: 8%">
        <img  v-show="!item.flag" src="../assets/make/rightDialog/right-dialog-close.png" style="width: 8%">
      </div>
      <transition name="answer">
        <div v-show="item.flag" class="answer">
          {{item.content}}
        </div>
      </transition>

    </div>
  </div>
</template>

<script>
  import api from "../makeOnlineApi/api";
    export default {
        name: "QuestionDialog",
        data(){
          return{
              answerAni:0,
              questionList:[]

          }
        },
        created() {
            api.getCommonProblem().then(res=>{
                console.log(res.data.result)
                this.questionList=res.data.result.map(item=>{
                    return {
                        ...item,
                        flag:false
                    }
                })
            })

        },
        methods:{
            clickSwitch(index,item,flag){
                const count =  this.questionList.filter(item=>{
                    return item.flag===true
                }).length
                this.questionList=this.questionList.map(item=>{
                    return {
                        ...item,
                        flag:false
                    }
                })
                if (count===0){
                    this.questionList.splice(index,1,{...item,flag:!flag})
                }else {
                    let that = this

                    setTimeout(function () {
                        that.questionList.splice(index,1,{...item,flag:!flag})
                    },505)
                }


            }
        }
    }
</script>

<style scoped>
  .right-dialog{
    height: 82.5%;
    width: 20%;
    position: absolute;
    top: 11%;
    right: 0;
    background-color: #FFFFFF;
    display: flex;
    flex-direction: column;
    align-items: center;
    box-shadow: 0px 0px 10px #D0D6DF;
    overflow-y: auto;
  }
  .title{
    display: flex;
    align-items: center;
    width: 100%;
    padding-top: 8%;
    background-color: white;
    z-index: 5;
    position: relative;
  }
  .title-text{
    font-size: 16px;
    color: #35315C;
    font-weight: bold;
  }
  .trapezoid{
    width:10px;
    height:10px;
    background-color:rgba(0,0,0,0);
    border-top:4px solid rgba(0,0,0,0);
    border-right:4px solid rgba(0,0,0,0);
    border-bottom:4px solid rgba(0,0,0,0);
    border-left:4px solid #FF7BAC;
  }
  .item{
    width: 90%;
    position: relative;

  }
  .question{
    display: flex;
    justify-content: space-between;
    font-size: 13px;
    color: #35315C;
    align-items: flex-start;
    align-content: flex-start;
    padding-top: 15px;
    padding-bottom: 10px;
    position:relative;
    background-color: white;
    z-index: 5;

  }
  .answer{
    border-radius: 4px;
    /*transform: translateY(-100%);*/
    background-color: #F9FAFF;
    width: 94%;
    padding: 8px 3%;
    font-size: 12px;
    color: rgba(53,49,92,0.5);
    position:relative;
    z-index: 4;
    white-space: pre-line;
  }

  .answer-enter-active {
    animation: answer-in 0.5s;
  }
  .answer-leave-active {
    animation: answer-in 0.5s reverse;
  }
  @keyframes answer-in {
    0% {
      /*height: 0;*/
      transform: translateY(-100%);
    }

    100% {
      /*height: 100%;*/
      transform: translateY(0px);
    }
  }


</style>
